<template>
  <div class="specialist-goals">
    <h2>Coming soon!</h2>
  </div>
</template>

<script>
export default {
  name: 'SpecialistGoals'
};
</script>

<style scoped>
.specialist-goals {
  padding: 40 60px;
  color: black;
  font-size: 20px;
}
</style>
